module.exports = __webpack_public_path__ + "img/401.adbbe648.png";